<template>
    <div :class="['page page--light page--overflow-y-unset', { 'page--embed': partnerAppEmbedCustomization }]">
        <section class="row gradient-background">
            <div class="wrapper wrapper--no-max-width">
                <header :class="['row__header', { 'row__header--partner-app': isPartnerApp }, {'topup__header--arabic': isARLocale}]">
                    <back-button
                        v-if="!isARLocale"
                        :isAbsolute="false"
                        :isBlack="true"
                        routeToHome
                    />

                    <h1>{{ $t('wallet.topup') }}</h1>

                    <back-button
                        v-if="isARLocale"
                        :isAbsolute="false"
                        :isBlack="true"
                        :isArabic="true"
                        routeToHome
                    />
                </header>

                <component :is="componentToRender"
                    v-bind="$props"
                />
            </div>
        </section>
    </div>
</template>

<script>
// 3rd party
import {
    mapGetters,
} from 'vuex';

// Components
import backButton from '@webapp/components/back-button/back-button.vue';

export default {
    name: 'wallet-topup',
    components: {
        backButton,
    },
    props: {
        balance: {
            type: String,
            default: '',
        },

        amountToCompleteFTPurchase: {
            type: Number,
            default: 0,
        },
    },
    computed: {
        ...mapGetters([
            'currentRegulation',
            'getLatestValidationError',
            'isPartnerApp',
            'isARLocale',
            'partnerAppEmbedCustomization',
        ]),

        componentToRender() {
            return () => import(`@webapp/views/wallet/topup/${this.currentRegulation.toLowerCase()}/topup.vue`);
        },
    },
    watch: {
        getLatestValidationError(newValue) {
            if (Object.values(newValue).length) {
                this.$notify({
                    type: 'error',
                    text: newValue,
                });
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.topup {
    &__header {
        &--arabic {
            text-align: right;
            padding-right: 30px;
        }
    }
}
</style>